<template>
  <div class="match_level_count">
    <ul class="team_name_logo">
      <li>
        <span class="logo">
          <img v-if="matchInfo.home_logo.length > 0" :src="matchInfo.home_logo" />
          <img v-else src="./img/football.png" />
        </span>
        <strong v-if="matchInfo">{{ matchInfo.home }}</strong>
      </li>
      <li class="icon_compare">VS</li>
      <li class="last">
        <span class="logo">
          <img v-if="matchInfo.away_logo.length > 0" :src="matchInfo.away_logo" />
          <img v-else src="./img/football.png" />
        </span>
        <strong>{{ matchInfo.away }}</strong>
      </li>
    </ul>

    <div v-loading="loading">
      <dl class="tow_team_current_score">
        <dt>
          <div class="status_number">
            <span class="icon"><img src="./img/match_status/10.png" /></span>
            <span class="num">
              <img v-for="(num, index) of $parent.numToArray(homeScore.red_card)" :key="index" :src="require(`./img/numbers/black_${num}.png`)" />
            </span>
          </div>
          <div class="status_number">
            <span class="icon"><img src="./img/match_status/9.png" /></span>
            <span class="num">
              <img v-for="(num, index) of $parent.numToArray(homeScore.yellow_card)" :key="index" :src="require(`./img/numbers/black_${num}.png`)" />
            </span>
          </div>
          <div class="status_number">
            <span class="icon"><img src="./img/match_status/8.png" /></span>
            <span class="num">
              <img v-for="(num, index) of $parent.numToArray(homeScore.corner_kick)" :key="index" :src="require(`./img/numbers/black_${num}.png`)" />
            </span>
          </div>
        </dt>
        <dd>
          <div class="status_number">
            <span class="icon"><img src="./img/match_status/8.png" /></span>
            <span class="num">
              <img v-for="(num, index) of $parent.numToArray(awayScore.corner_kick)" :key="index" :src="require(`./img/numbers/black_${num}.png`)" />
            </span>
          </div>
          <div class="status_number">
            <span class="icon"><img src="./img/match_status/9.png" /></span>
            <span class="num">
              <img v-for="(num, index) of $parent.numToArray(awayScore.yellow_card)" :key="index" :src="require(`./img/numbers/black_${num}.png`)" />
            </span>
          </div>
          <div class="status_number">
            <span class="icon"><img src="./img/match_status/10.png" /></span>
            <span class="num">
              <img v-for="(num, index) of $parent.numToArray(awayScore.red_card)" :key="index" :src="require(`./img/numbers/black_${num}.png`)" />
            </span>
          </div>
        </dd>
      </dl>

      <template v-if="countTotal > 0">
        <dl class="level_count_scores" v-for="(item, index) of scoreList" :key="index" v-if="item">
          <dd class="team_red" > 
            <span :style="`width: ${$parent.getRatio(item, item)}%`"></span>
          </dd>
          <dt>
            <span class="score" >
              <img v-for="(num, index) of $parent.numToArray(item.home, true)" :key="index" :src="require(`./img/numbers/black_${num}.png`)" />
            </span>
            <span class="text" >{{ fballTypes[item.type].name }}</span>
            <span class="score">
              <img v-for="(num, index) of $parent.numToArray(item.away, true)" :key="index" :src="require(`./img/numbers/black_${num}.png`)" />
            </span>
          </dt>
          <dd class="team_blue" >
            <span :style="`width: ${$parent.getRatio(item.away, item.home)}%`"></span>
          </dd>
        </dl>
      </template>
    </div>

    <div v-if="countTotal == 0 && loading == false">
      <panel-not-data message="当前赛事没有技术统计数据..." img-name="vs" />
    </div>
    <!--足球图示-->
    <football-icons />
  </div>
</template>

<script>
//引入足球图标
import FootballIcons from "./fball_icons";
//引入公用无数据组件
import PanelNotData from "@/components/match-recommend/not-data";

export default {
  name: "FootballCounter",
  data() {
    return {
      loading: true,
      //是否有比分数据
      countTotal: 0,
      //主队红黄牌是否大于0
      countHomeScore: 0,
      //客队红黄牌是否大于0
      countAwayScore: 0,
      //主队得分
      homeScore: {},
      //客队得分
      awayScore: {},
      //两队分值对比图
      scoreList: [],
    };
  },
  components: {
    FootballIcons,
    PanelNotData,
  },
  props: {
    matchInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    fballTypes: {
      type: Object,
    },
  },
  mounted() {
    //增加强行关闭动画的定时器
    setTimeout(() => {
      this.loading = false;
    }, 20000);
  },
  methods: {
    /**
     * 处理数据
     * @param {string} ret_data 接收到的数据
     */
    fbCounterRunData(ret_data) {
      let data_list = JSON.parse(ret_data.replace(/[\\]+/g, "").slice(1, -1));
       console.log("football counter足球技术统计数据：", data_list);
      //处理红黄牌数据
      if (data_list.length >= 1 && data_list[0].type == "scoreLive") {
        if (data_list[0].football_scores) {
          this.homeScore = data_list[0].football_scores.home_score;
          this.awayScore = data_list[0].football_scores.away_score;
          if (this.homeScore.red_card == 0 && this.homeScore.yellow_card == 0 && this.homeScore.corner_kick == 0) {
            this.countHomeScore++;
          }
          if (this.awayScore.red_card == 0 && this.awayScore.yellow_card == 0 && this.awayScore.corner_kick == 0) {
            this.countAwayScore++;
          }
        }
      }
      //接收比分
      if (data_list.length == 2 && data_list[1].type == "statsLive") {
        let score_list = data_list[1].stats_live;
         console.log("score_list:", score_list);
        //重新按type的先小后大顺序排序
        let score_arr = [];
        score_list.forEach((res, index) => {
          if (res.home > 0 || res.away > 0) {
            this.countTotal++;
          }
          score_arr[res.type] = {
            home: res.home,
            away: res.away,
            type: res.type,
          };
        });
        //再次加工，去除无效的空元素
        let score_new = [];
        let key = 0;
        [...score_arr].forEach((item) => {
          if (item != "undefined") {
            score_new[key] = item;
            key++;
          }
        });
        this.scoreList = score_new;
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
//[足球-技术统计]对应的内容块部分
.match_level_count {
  .tow_team_current_score {
    display: flex;
    justify-content: space-between;
    clear: both;
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 10px 60px;

    dt,
    dd {
      display: flex;
      justify-content: space-between;
      width: 2rem;
      overflow: hidden;
    }

    .status_number {
      float: left;
      width: auto;
      overflow: hidden;
      padding-bottom: 0.1rem;

      .icon,
      .num {
        display: block;
        clear: both;
        width: 0.28rem;
        height: 0.28rem;
        overflow: hidden;
        background-color: #f9f9fb;
        border-radius: 0.2rem;
        box-sizing: border-box;
        padding: 0.03rem;
        margin: 0 auto;

        img {
          display: block;
          height: 100%;
          margin: 0 auto;
        }
      }

      .num {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 0.2rem;
        background-color: transparent;
        border-radius: 0;
        margin-top: 0.1rem;
      }
    }
  }

  .level_count_scores {
    display: flex;
    justify-content: space-between;
    align-items: center;
    clear: both;
    width: 100%;
    height: 50px;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0px 60px;

    dd {
      flex-shrink: 0;
      width: 3.2rem;
      height: 8px;
      overflow: hidden;
      background-color: #dddfec;

      span {
        display: block;
        float: left;
        width: 0px;
        height: 100%;
        overflow: hidden;
      }
    }

    dd.team_red {
      span {
        float: right;
        background-color: #f45b63;
      }

      span.trans_half {
        background-color: rgba(244, 91, 99, 0.5);
      }
    }

    dd.team_blue {
      span {
        background-color: #4174f2;
      }

      span.trans_half {
        background-color: rgba(65, 116, 242, 0.5);
      }
    }

    dt {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 100%;
      overflow: hidden;
      padding: 0px 10px;

      .score {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30%;
        height: 100%;
        overflow: hidden;

        img {
          display: inline-block;
          height: 12px;
          margin: 0px 2px;
        }
      }

      .text {
        flex-shrink: 0;
        width: 40%;
        height: 100%;
        line-height: 50px;
        overflow: hidden;
        font-size: 0.14rem;
        color: #666;
        text-align: center;
        font-weight: 400;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: break-all;
      }
    }
  }
}
</style>